import { render, staticRenderFns } from "./convenis.vue?vue&type=template&id=62ca87b4&scoped=true&"
import script from "./convenis.vue?vue&type=script&lang=js&"
export * from "./convenis.vue?vue&type=script&lang=js&"
import style0 from "./convenis.vue?vue&type=style&index=0&id=62ca87b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ca87b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDivider,VFlex,VLayout})
